import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "../../assets/icons";
import * as Images from "../../assets/images";

const Footer = () => {
  const routes = [
    {
      path: "/",
      name: "Home",
      sectionName: "/",
    },
    {
      path: "/#aboutSection",
      name: "About",
      sectionName: "#aboutsection",
    },
    {
      path: "/products",
      name: "Products",
      sectionName: "#productssection",
    },
    {
      path: "/pages",
      name: "Sectors",
      sectionName: "#sectorsection",
    },
    {
      path: "/blog",
      name: "Blog",
      sectionName: "#blogsection",
    },
    {
      path: "/contact",
      name: "Contact Us",
      sectionName: "#contactsection",
    },
  ];
  const services = [
    {
      path: "/",
      name: "Waste Collection",
    },
    {
      path: "/about",
      name: "Recycling Services",
    },
    {
      path: "/services",
      name: "Hazadous Waste Disposal",
    },
    {
      path: "/pages",
      name: "Bulk Waste Removal",
    },
    {
      path: "/blog",
      name: "Medical Waste Management",
    },
  ];

  return (
    <>
      <div className="bg-primary">
        <div className="grid  gap-12 lg:grid-cols-3  lg:grid-flow-col  px-8 py-24 lg:px-64">
          <div className="text-white px-4 grid gap-8">
            <div>
              <img src={Images.GabeLogo} className="h-16 " alt="logo" />
            </div>
            <div>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam
                auctor, nisl ac ultrices ultricies, tortor urna aliquet justo,
                id tincidunt nunc nisl id nunc.
              </p>
            </div>
            <div className="flex items-center gap-4">
              <a href="https://www.facebook.com">
                <Icons.Facebook className="h-7 w-7" />
              </a>
              <a href="https://www.twitter.com">
                <Icons.Twitter className="h-7 w-7" />
              </a>
              <a href="https://www.instagram.com">
                <Icons.Instagram className="h-7 w-7" />
              </a>
              <a href="https://www.youtube.com">
                <Icons.Youtube className="h-7 w-7" />
              </a>
            </div>
          </div>
          <div className="grid md:grid-cols-2 md:justify-around ">
            <div className="flex flex-col text-lg text-white gap-1 font-semibold">
              <p className=" text-2xl font-bold mb-3">Quick links</p>
              {routes.map((route) => (
                <React.Fragment key={route.name}>
                  <div className="flex items-center gap-1">
                    <Icons.ArrowRight className="h-5 w-5 text-yellow-400" />
                    <a
                      href={`${route.sectionName}`}
                      className="hover:text-yellow-400"
                    >
                      {route.name}
                    </a>
                  </div>
                </React.Fragment>
              ))}
            </div>

            <div className="flex flex-col text-lg text-white gap-1 font-semibold">
              <p className=" text-2xl font-bold mb-3">Services</p>
              {services.map((service) => (
                <React.Fragment key={service.name}>
                  <div className="flex items-center gap-1">
                    <Icons.ArrowRight className="h-5 w-5 text-yellow-400" />
                    <Link to={service.path} className="hover:text-yellow-400">
                      {service.name}
                    </Link>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>
          <div className="flex flex-col text-lg text-white gap-1 font-semibold">
            <p className=" text-2xl font-bold mb-3">Information</p>
            <div className="grid gap-4">
              <div className="flex gap-2">
                <Icons.Phone className=" h-8 w-8 text-white" />
                <div>
                  <p>Phone</p>
                  <span className="text-sm">
                    +971561273920 | 0565841949 | +917906060759 | 09707847307{" "}
                  </span>
                </div>
              </div>
              <div className="flex gap-2">
                <Icons.Mail className="h-8 w-8 text-white" />
                <div>
                  <p>Email</p>
                  <div className="flex flex-col">
                    <p className="text-sm">aamirarab888@gmail.com</p>
                    <p className="text-sm">aamirearab7@icloud.com</p>
                  </div>
                </div>
              </div>
              <div className="flex gap-2">
                <Icons.Address className="h-8 w-8 text-white" />
                <div>
                  <p>Address</p>
                  <span className="text-sm">
                    Sharjah Media City, Sharjah, UAE
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className=" border-b border-white mx-8 lg:mx-64"></div>
        <div className=" mx-8 lg:mx-64 py-4 text-white text-center">
          Copyright {new Date().getFullYear()} © All Right Reserved Design by
          Global Trek Express Trading LLC
        </div>
      </div>
    </>
  );
};

export default Footer;
